export default "__VITE_ASSET__BwhILiNq__"